import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(public translate: TranslateService, private router: Router, private location: Location) { }

  ngOnInit() {
  }

  goToMainPage() {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }
    this.router.navigate(['/contracts']);
  }
}
